import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { array, bool, func, number, string } from 'prop-types';
import cn from 'classnames';
import style from './panel.module.css';
import PanelButton from './PanelButton.jsx';
import Lottie from 'modules/emoji/_components/Lottie.jsx';

export default Panel;

Panel.propTypes = {
  emojiArray: array,
  isFullscreen: bool,
  emojiContainerHeight: number,
  panelOrientation: string,
  setPanelOrientation: func.isRequired,
};

Panel.defaultProps = {
  emojiArray: [],
  isFullscreen: false,
};

function Panel(props) {
  const {
    emojiArray,
    isFullscreen,
    getAssetByUrl,
    emojiContainerHeight,
    panelOrientation,
    setPanelOrientation,
    onSendEmoji,
    children,
  } = props;
  const [enableAnimation, disableAnimation] = useMemo(() => {
    return [
      (name) => {
        // doubtful solution, quick and dirty,
        // rewrite once it will bring a problem
        window.lottie.play(`button_${name}`);
      },
      (name) => {
        window.lottie.stop(`button_${name}`);
      },
    ];
  }, []);
  /**
   * @type {React.MutableRefObject<HTMLElement>}
   */
  const panelRef = useRef();

  const checkPanelOrientation = useCallback(() => {
    if (
      emojiContainerHeight !== 0 &&
      panelRef.current.offsetHeight > emojiContainerHeight &&
      panelOrientation !== 'horizontal'
    ) {
      setPanelOrientation('horizontal');
    }
  }, [emojiContainerHeight, panelOrientation, setPanelOrientation]);

  useEffect(
    () => {
      checkPanelOrientation();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [emojiContainerHeight],
  );

  useEffect(() => {
    window.addEventListener('resize', checkPanelOrientation);

    return () => {
      setPanelOrientation('vertical');
      window.removeEventListener('resize', checkPanelOrientation);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!emojiContainerHeight) {
    return null;
  }

  return (
    <section
      className={cn({
        [style.container]: true,
        [style.containerVertical]: panelOrientation === 'vertical',
        [style.containerHorizontal]: panelOrientation === 'horizontal',
      })}
      ref={panelRef}
    >
      {/*
That button seems redundant due to mode toggling now available from player's skin
        <Button onClick={requestClose} className={style.close}>
          <img src={closeIcon} alt={'Close emoji panel'} />
        </Button>
*/}
      {emojiArray.map(({ name, url }) => (
        <PanelButton
          name={name}
          key={name}
          onClick={onSendEmoji}
          onActive={enableAnimation}
          onInactive={disableAnimation}
          // isFullscreen={isFullscreen}
        >
          <Lottie
            autoplay={false}
            animationData={getAssetByUrl(url).data}
            name={name}
          />
        </PanelButton>
      ))}
      {children}
    </section>
  );
}
